module.exports = __webpack_public_path__ + "assets/img/Logitech-G-4-Social-Static-Ad.93ae45b5.png";